import React from 'react';

import {
  AccountScreenContainer,
  AccountScreenSection,
  AccountScreenTitle,
  ActiveBagWarning,
  AddressList,
  useActiveBagWarning,
} from '@order/components';
import { useCustomer } from '@order/Customer';
import { useLocalizationContext } from '@order/Localization';

import type { AddressesScreenProps } from '../../navigation/AppNavigation.props';

export const AddressesScreen = ({ navigation }: AddressesScreenProps) => {
  const {
    customer: { addresses },
  } = useCustomer();
  const { t } = useLocalizationContext();

  const handleSelectAddress = React.useCallback(
    (addressId: string) => {
      navigation.navigate('Modal', {
        screen: 'AddressEdit',
        params: { addressId },
      });
    },
    [navigation],
  );

  const handleSelectAddAddress = React.useCallback(() => {
    navigation.navigate('Modal', { screen: 'AddressAdd' });
  }, [navigation]);

  const {
    activeBagWarning,
    closeActiveBagWarning,
    confirmEditAddress,
    onEdit,
  } = useActiveBagWarning(handleSelectAddress);

  return (
    <AccountScreenContainer screen="addresses">
      <AccountScreenTitle title={t('account.addresses.title')} />
      <AccountScreenSection>
        <AddressList
          items={addresses ?? []}
          onSelectItem={onEdit}
          onSelectAdd={handleSelectAddAddress}
        />
      </AccountScreenSection>

      <ActiveBagWarning
        visible={Boolean(activeBagWarning)}
        onClose={closeActiveBagWarning}
        onConfirm={confirmEditAddress}
      />
    </AccountScreenContainer>
  );
};
